import { createFileRoute, redirect } from '@tanstack/react-router';

import { CrmTriggersPage } from '@/features/admin-terminal/components/crm-triggers';
import { isProductionRuntime } from '@/lib/app-env';

/**
 * The CRM trigger page (ENG-2172): fire each team-CRM automation by hand on a
 * PR preview. Off production the API answers 404 for it anyway; the route
 * sends a production runtime back to the admin home so the page never shows
 * there (same runtime read as the wireframes gate, see `lib/app-env.ts`).
 */
export const Route = createFileRoute('/_admin/admin/crm-triggers')({
  beforeLoad: () => {
    if (isProductionRuntime()) {
      throw redirect({ to: '/admin' });
    }
  },
  component: CrmTriggersPage,
});
